import * as React from "react";
import { useConfirmation } from "../../services/ConfirmationService";
import DeleteIcon from "@material-ui/icons/Delete";
import TableStyle from "../shared/Styling/TableStyling";
import IDocument from "../../models/IDocument";

interface ID {
    document: IDocument;
    onRemoveDocument(): void;
}

const DocumentsDeleteButton: React.FC<ID> = ({
    document,
    onRemoveDocument
}) => {
    const confirm = useConfirmation();

    const classes = TableStyle();

    const tryToKill = () => {
        confirm({
            variant: "danger",
            catchOnCancel: true,
            title: "Delete File?",
            description: `Are you sure you wish to delete the selected file '${document.name}'?`,
            cancelText: "Keep File",
            confirmationText: "Delete File"
        })
            .then(() => onRemoveDocument())
            .catch(/* DO NOTHING */);
    };

    return (
        <DeleteIcon
            onClick={tryToKill}
            className={`${classes.button} ${classes.icon}`}
        />
    );
};

export default DocumentsDeleteButton;
